import { render, staticRenderFns } from "./DataListArchive.vue?vue&type=template&id=c17a766a&"
import script from "./DataListArchive.vue?vue&type=script&lang=js&"
export * from "./DataListArchive.vue?vue&type=script&lang=js&"
import style0 from "./DataListArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports